import type { Word } from '../types';

/**
 * Las palabras sin repetir y en orden alfabético. Es `allWords` del store, y la
 * página de impresión (src/print/) la usa igual sin cargar el store entero.
 */
export function dedupeAlphabetical(items: Word[]): Word[] {
  const seen = new Set<string>();
  const out: Word[] = [];
  for (const it of items) {
    if (seen.has(it.word)) continue;
    seen.add(it.word);
    out.push(it);
  }
  return out.sort((a, b) => a.word.localeCompare(b.word, 'es'));
}
